import { useLocaleNavigation } from "@/hooks/use-locale-navigation";
import { Link } from "@tanstack/react-router";
import React from "react";

export default function I18NLink({
  to,
  children,
  className,
  onClick,
}: {
  to: string;
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}) {
  const { getLocalizedPath } = useLocaleNavigation();
  return (
    <Link to={getLocalizedPath(to)} className={className} onClick={onClick}>
      {children}
    </Link>
  );
}
